import { tsMethodSignature } from "@babel/types";
import { ComponentView } from "binder";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { getAsBoolean } from "../utilities";
import { TextInputViewModel } from "./textInput-viewModel"

export class TextInputView extends ComponentView<TextInputViewModel>{
    GetViewUniqueId(): string {
        return "V-5F5F0D20-D929-41DB-85D2-DEACC2549B06"
    }
    loadHtml(): string {
        let element = require('./textInput.html').default;
        let style = require('./textInput.less');
        return element;
    }
    constructor() {
       super();
       this.isshowingpassword = false;
       this.isEventsSet = false;
       this.isShowingCopiedMessage = false;
    }

    public set text(v: string) { 
        this._text = v;
        this.inputElement.value = this._text;
    } public get text(): string {
        let a = this._text;
        if(a!=null && a!='' && this.slots!=null && this.slots!=''){
            a=a.toString();
            let index = [...this.slots].map(x=>a.indexOf(x)).filter(x=>x>=0).reduce((p,c)=>p<c?p:c,100000);
            a=a.substring(0,index);
        }
        return a;
    } private _text: string;
    public set showingText(v: string) { this._showingText = v; } public get showingText(): string { return this._showingText;} private _showingText: string;
    public set ispassword(v: boolean) { this._ispassword = v; } public get ispassword(): boolean { return this._ispassword;} private _ispassword: boolean;
    public set isshowingpassword(v: boolean) { this._isshowingpassword = v; } public get isshowingpassword(): boolean { return this._isshowingpassword;} private _isshowingpassword: boolean;
    public set isreadonly(v: boolean) { this._isreadonly = v; } public get isreadonly(): boolean { return this._isreadonly;} private _isreadonly: boolean;
    public set disabled(v: boolean) { this._disabled = v; } public get disabled(): boolean { return this._disabled;} private _disabled: boolean;
    public set isnumeric(v: boolean) { this._isnumeric = v; } public get isnumeric(): boolean { return this._isnumeric;} private _isnumeric: boolean;
    public set maxlength(v: number) { this._maxlength = v; } public get maxlength(): number { return this._maxlength;} private _maxlength: number;
    public set min(v: number) { this._min = v; } public get min(): number { return this._min;} private _min: number;
    public set max(v: number) { this._max = v; } public get max(): number { return this._max;} private _max: number;
    public set inputElement(v: HTMLInputElement) { 
        this._inputElement = v; 
        this.SetupRegex();
    } public get inputElement(): HTMLInputElement { return this._inputElement;} private _inputElement: HTMLInputElement;
    public set placeholder(v: string) { 
        this._placeholder = v; 
        this.SetupRegex();
    } public get placeholder(): string { return this._placeholder;} private _placeholder: string;
    public set slots(v: string) { 
        this._slots = v; 
        this.SetupRegex();
    } public get slots(): string { return this._slots;} private _slots: string;
    public set accepts(v: string) { 
        this._accepts = v; 
    } public get accepts(): string { return this._accepts;} private _accepts: string;
    public set cancopy(v: boolean) { this._cancopy = v; } public get cancopy(): boolean { return this._cancopy;} private _cancopy: boolean;
    public set isShowingCopiedMessage(v: boolean) { this._isShowingCopiedMessage = v; } public get isShowingCopiedMessage(): boolean { return this._isShowingCopiedMessage;} private _isShowingCopiedMessage: boolean;
    
    public set allowsuggestion(v: boolean) { 
        this._allowsuggestion = getAsBoolean(v);
        this.handleSuggestion();
    } public get allowsuggestion(): boolean { return this._allowsuggestion;} private _allowsuggestion: boolean;
    public set suggestions(v: string[]) { 
        this._suggestions = v; 
        this.handleSuggestion();
    } public get suggestions(): string[] { return this._suggestions;} private _suggestions: string[];
    public set suggestionsseparator(v: string) { 
        this._suggestionsseparator = v; 
        this.handleSuggestion();
    } public get suggestionsseparator(): string { return this._suggestionsseparator;} private _suggestionsseparator: string;


    keyup(x){
        this.firstlevelElement.dispatchEvent(new x.constructor(x.type,x));
    }
    blur(x){
        this.firstlevelElement.dispatchEvent(new x.constructor(x.type,x));
    }
    focusInput(){
        this.inputElement.focus();
    }

    typeConverter(t){
        let [password,numeric] = t;
        if(password){
            return 'password';
        }else if(numeric){
            return 'number';
        }else{
            return 'text'
        }
    }
    private defaultInputHandler;
    onRenderCompleted(){
        this.inputElement = <HTMLInputElement>(this.firstlevelElement.querySelector('.V-5F5F0D20-D929-41DB-85D2-DEACC2549B06'));
        if(this.isEventsSet==false){
            this.defaultInputHandler = ()=>this.handleInputEvent();
            this.inputElement.addEventListener("input",this.defaultInputHandler);
        }
        
        this.handleSuggestion();
    }

    handleSuggestion(){
        let realThis = this;
        if(this.inputElement && this.allowsuggestion==true && this.suggestionsseparator!=null && this.suggestions && this.suggestions.length>0){
            function split( val ) {
                return val.split( /\s+/ );
            }
            function extractLast( term ) {
                return split( term ).pop();
            }
            let suggestions = this.suggestions;
            let firstLevelElement = this.firstlevelElement;
            (<any>$(this.inputElement))
            .on( "keydown", function( event ) {
                if ( event.keyCode === (<any>$).ui.keyCode.TAB && 
                    (<any>$(this)).autocomplete( "instance" ).menu.active ) {
                  event.preventDefault();
                }
              })
            .autocomplete({
                minLength: 0,
                appendTo:firstLevelElement,
                source: function( request, response ) {
                  // delegate back to autocomplete, but extract the last term
                  response( (<any>$).ui.autocomplete.filter(
                    suggestions, extractLast( request.term ) ) );
                },
                focus: function() {
                  // prevent value inserted on focus
                  return false;
                },
                select: function( event, ui ) {
                  var terms = split( this.value );
                  // remove the current input
                  terms.pop();
                  // add the selected item
                  terms.push( ui.item.value );
                  // add placeholder to get the comma-and-space at the end
                  terms.push( "" );
                  this.value = terms.join(" ");
                  realThis.text = this.value;
                  return false;
                }
              });
        }
    }

    handleInputEvent(){
        if(this.maxlength && this.inputElement.value.length>this.maxlength)
            this.inputElement.value=this.inputElement.value.substring(0,this.maxlength);
        else
            this.text=this.inputElement.value;
    }
    hidePassword(){
        this.inputElement.type = 'password'
        this.isshowingpassword = false;
    }
    showPassword(){
        this.inputElement.type = '';
        this.isshowingpassword = true;
    }
    copy(){
        let element =this.inputElement;
        element.select();
        element.setSelectionRange(0, 99999); 
        document.execCommand("copy");
        this.dataContext.showCopiedMessage()
    }
    toggleHidePassword(){
        if(this.isshowingpassword==true){
            this.hidePassword();
        }else{
            this.showPassword();
        }
    }

    public onDataContextSet() {
        this.dataContext.focusInput = this.focusInput.bind(this);
    }
    private isEventsSet:boolean;
    SetupRegex(){
        return;
        if(this.isEventsSet==true)
            return;
        if(this.inputElement==null)
            return;
        if(this.placeholder==null)
            return;
        if(this.slots==null)
            return;
        let pattern = this.placeholder;
        let slots =new Set<string>(this.slots ?? '_');
        let prev = (j => Array.from(pattern, (c,i) => slots.has(c)? j=i+1: j))(0);
        let first = [...pattern].findIndex(c => slots.has(c));
        let accept = new RegExp(this.accepts || "\\d", "g");
        
        let clean = input => {
            input = input.match(accept) || [];
            return Array.from(pattern, c =>
                input[0] === c || slots.has(c) ? input.shift() || c : c
            );
        };
        let format = () => {
            const [i, j] = [this.inputElement.selectionStart, this.inputElement.selectionEnd].map(i => {
                i = clean(this.inputElement.value.slice(0, i)).findIndex(c => slots.has(c));
                return i<0? prev[prev.length-1]: back? prev[i-1] || first: i;
            });
            this.inputElement.value = clean(this.inputElement.value).join(``);
            this.inputElement.setSelectionRange(i, j);
            back = false;
        };
        let formatInput = () => {
            format();
            this.text=this.inputElement.value;
            back = false;
        };
        let back = false;
        this.inputElement.addEventListener("keydown", (e) => back = e.key === "Backspace");
        if(this.defaultInputHandler!=null)
            this.inputElement.removeEventListener("input",this.defaultInputHandler);
        this.inputElement.addEventListener("input", formatInput);
        this.inputElement.addEventListener("focus", format);
        this.inputElement.addEventListener("blur", () => this.inputElement.value === pattern && (this.inputElement.value=""));
    }
}
